import {
  createAdCampaignEpic,
  createAdCampaignObservable,
} from './createAdCampaign'
import {
  deleteAdCampaignEpic,
  deleteAdCampaignObservable,
} from './deleteAdCampaign'
import { getAdCampaignEpic, getAdCampaignObservable } from './getAdCampaign'
import { getPaidAdsEpic, getPaidAdsObservable } from './getPaidAds'
import {
  postAdCampaignInvitationsEpic,
  postAdCampaignInvitationsObservable,
} from './postAdCampaignInvitations'
import {
  publishAdCampaignEpic,
  publishAdCampaignObservable,
} from './publishAdCampaign'
import {
  updateAdCampaignEpic,
  updateAdCampaignObservable,
} from './updateAdCampaign'
import {
  deleteAdCampaignInvitationsEpic,
  deleteAdCampaignInvitationsObservable,
} from './deleteAdCampaignInvitations'

export const observables = {
  createAdCampaignObservable,
  deleteAdCampaignObservable,
  deleteAdCampaignInvitationsObservable,
  getAdCampaignObservable,
  getPaidAdsObservable,
  postAdCampaignInvitationsObservable,
  publishAdCampaignObservable,
  updateAdCampaignObservable,
}

export default {
  createAdCampaignEpic,
  deleteAdCampaignEpic,
  deleteAdCampaignInvitationsEpic,
  getAdCampaignEpic,
  getPaidAdsEpic,
  postAdCampaignInvitationsEpic,
  publishAdCampaignEpic,
  updateAdCampaignEpic,
}
